import React from 'react';

/** 로딩 시 전체 화면 덮는 모달 (stub) */
export function LoadingModal() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl px-8 py-6 shadow-xl">로딩 중...</div>
    </div>
  );
}

/** 메시지 알림 모달 (stub) */
export function MessageModal({ message }) {
  if (!message) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl px-8 py-6 shadow-xl max-w-md">{message}</div>
    </div>
  );
}
